$(document).on("turbolinks:load", () => {
  if (!$("body.admin_inland_transports").length) {
    return;
  }

  const timeValues = [];
  for (let i = 0; i < 24; i++) {
    timeValues.push(`${i}:00`);
    timeValues.push(`${i}:30`);
  }

  const minDate = $(".min-date-value").text().trim() || false;
  const maxDate = $(".max-date-value").text().trim() || false;

  const updateMinDate = () => {
    $(".address-datetime-picker").datetimepicker({
      formatDate: "%Y-%m-%d",
      scrollMonth: false,
      allowTimes: timeValues,
      minDate: minDate,
      maxDate: maxDate,
    });
  };

  updateMinDate();

  $(".button.has_many_add").on("click", () => {
    setTimeout(updateMinDate, 300);
  });
});
